var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconOpenInNew48Line = function SvgIconOpenInNew48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3 33.4a1.9 1.9 0 0 1-1.9 1.9H14.6a1.9 1.9 0 0 1-1.9-1.9V16.6c0-1.05.85-1.9 1.9-1.9H24v-3.4h-9.4a5.31 5.31 0 0 0-5.3 5.3v16.8c0 2.92 2.38 5.3 5.3 5.3h16.8c2.92 0 5.3-2.38 5.3-5.3V24h-3.4v9.4Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.85 10.15c-.56-.56-1.37-.89-2.12-.85l-7.99.19.08 3.4 5-.12-8.77 8.77 2.4 2.4 8.77-8.77-.12 5 3.4.08.2-7.99c.02-.79-.29-1.56-.85-2.12v.01Z",
    fill: "current"
  })));
};
export default SvgIconOpenInNew48Line;